/**
 * Created by jpilz on 2/13/17.
 */
"use strict";
import {context} from '../../objects/context.js';
import jobObj from '../../objects/jobObj.js';
import jobEditModel from '../job-edit/job-edit';
import ko from 'knockout';
import _ from 'lodash';
import axios from 'axios';
import $ from 'jquery';
import 'jquery.scrollintoview';
import moment from 'moment';
import jobUtil from '../../objects/jobUtil';
import preferencesUtil from '../../objects/preferencesUtil';

import BootstrapDialog from 'bootstrap3-dialog/dist/js/bootstrap-dialog';

class jobListModel {

    constructor(params) {
        // Profile
        
        this.componentName = "job-list";
        this.context = context;
        this.customHeaderTitles = this.context.customHeaderTitles;
        this.id = this.context.util.guid();
        this.visible = ko.observable(false);
        this.debug = false;

        this.preferencesUtilObj = new preferencesUtil(context);

        this.searchTerm = ko.observable("");
        this.OnetSearchArray = ko.observableArray([]);

        this.editJobTitle = ko.observable(false);

        this.sortColumn = ko.observable("title");

        console.log("nav-job-list:constructor: optioncolumn6Visible: %o", context.preferences().columnViewList.optioncolumn6Visible);

        this.optioncolumn1Visible = ko.observable(context.preferences().columnViewList.optioncolumn1Visible);
        this.optioncolumn2Visible = ko.observable(context.preferences().columnViewList.optioncolumn2Visible);
        this.optioncolumn3Visible = ko.observable(context.preferences().columnViewList.optioncolumn3Visible);
        this.optioncolumn4Visible = ko.observable(context.preferences().columnViewList.optioncolumn4Visible);
        this.optioncolumn5Visible = ko.observable(context.preferences().columnViewList.optioncolumn5Visible);
        this.optioncolumn6Visible = ko.observable(context.preferences().columnViewList.optioncolumn6Visible);

        this.AscDescClass = ko.observable("glyphicon-arrow-down");
        
        this.context.eventManager.subscribe((loginObj) =>{
            console.log("nav-job-list:loginStatus: %o", loginObj);
            //this.init(loginObj);
        },this, "loginStatus");

        this.context.eventManager.subscribe((jobRefreshObj) =>{
            console.log("nav-job-list:jobRefresh:  jobRefreshObj: %o", jobRefreshObj);
            this.jobRefresh(jobRefreshObj);
        },this, "jobRefresh");

        this.context.eventManager.subscribe((navObj) =>{
            this.handleNavChanged(navObj);
        },this, "navChanged");

        this.context.preferences.subscribe( data => {
            console.log("nav-job-list::constructor:preferences.subscribe:");
            this.updateOptionColumn();
        });

        ko.components.register('tab-general', require('./tabGeneral/tabGeneral').default);
        //ko.components.register('tab-editor', require('./tabEditor/tabEditor').default);
        //ko.components.register('job-history', require('./job-history/job-history').default);
        ko.components.register('job-view', require('./job-view/job-view').default);

        console.log('nav-job-list:constructor  this: %o', this);
    }

    log(obj)
    {
        if(this.debug)
        {
            console.log(this.componentName() + ":");
            console.log(obj);
        }
    }

    init() {

        console.log("nav-job-list:init");
    }

    updateOptionColumn() {

        console.log("nav-job-list:updateOptionColumn");
        this.optioncolumn1Visible(context.preferences().columnViewList.optioncolumn1Visible);
        this.optioncolumn2Visible(context.preferences().columnViewList.optioncolumn2Visible);
        this.optioncolumn3Visible(context.preferences().columnViewList.optioncolumn3Visible);
        this.optioncolumn4Visible(context.preferences().columnViewList.optioncolumn4Visible);
        this.optioncolumn5Visible(context.preferences().columnViewList.optioncolumn5Visible);
        this.optioncolumn6Visible(context.preferences().columnViewList.optioncolumn6Visible);

    }

    jobRefresh(jobRefreshObj) {
        this.searchTerm("");
        this.searchJobs();
        let jobUtilObj = new jobUtil(this.context);

        console.log("nav-job-list:jobRefresh jobRefreshObj: %o, jobid: %o", jobRefreshObj, jobRefreshObj.jobRefreshObj.jobid);
        
        if(jobRefreshObj.updateNav)
        {
            this.context.eventManager.notifySubscribers("jobList","navChanged");
            jobUtilObj.setJobToSelected(jobRefreshObj.jobRefreshObj.jobid);
        }
        else
        {
            jobUtilObj.getJobList().then( response => {
                jobUtilObj.setJobToSelected(jobRefreshObj.jobRefreshObj.jobid);
            });

        }

    }

    clickColumnHide(columnid) {

        console.log("nav-job-list:clickColumnHide context.preferences: %o", this.context.preferences());

        console.log("nav-job-list:clickColumnHide: optioncolumn6Visible: %o", this.context.preferences().columnViewList.optioncolumn6Visible);

        switch(columnid)
        {
            case 1:
                this.optioncolumn1Visible(!this.optioncolumn1Visible());
                context.preferences().columnViewList.optioncolumn1Visible = this.optioncolumn1Visible();
            break;
            case 2:
                this.optioncolumn2Visible(!this.optioncolumn2Visible());
                context.preferences().columnViewList.optioncolumn2Visible = this.optioncolumn2Visible();
                break;
            case 3:
                this.optioncolumn3Visible(!this.optioncolumn3Visible());
                context.preferences().columnViewList.optioncolumn3Visible = this.optioncolumn3Visible();
                break;
            case 4:
                this.optioncolumn4Visible(!this.optioncolumn4Visible());
                context.preferences().columnViewList.optioncolumn4Visible = this.optioncolumn4Visible();

                break;
            case 5:
                this.optioncolumn5Visible(!this.optioncolumn5Visible());
                context.preferences().columnViewList.optioncolumn5Visible = this.optioncolumn5Visible();
                break;
            case 6:
                this.optioncolumn6Visible(!this.optioncolumn6Visible());
                context.preferences().columnViewList.optioncolumn6Visible = this.optioncolumn6Visible();
                break;

        }

        context.preferences.valueHasMutated();

        //this.preferencesUtilObj.updatePreferences();

        console.log("nav-job-list:clickColumnHide: end: optioncolumn6Visible: %o", context.preferences().columnViewList.optioncolumn6Visible);
    }

    savePreferences() {
        console.log("nav-job-list:savePreferences:");
        this.preferencesUtilObj.updatePreferences();
    }

    handleNavChanged(navObj) {
        
        this.log("nav-job-list: handleNavChanged");
        this.log(navObj);

        if(navObj == 'jobList')
        {
            this.visible(true);
        }
        else
        {
            this.visible(false);
        }

    }

    searchJobs() {

        console.log("nav-job-list:searchJobs: searchTerm(): %o", this.searchTerm());

        let jobUtilObj = new jobUtil(this.context);
        jobUtilObj.closeAllJobs();

        if(this.searchTerm().length != 0)
        {
            this.searchUserJobs(this.searchTerm());
            this.searchONetJobs(this.searchTerm());
        }
        else
        {
            
            this.viewAllJobs();
            //this.OnetSearchArray([]);
            //this.viewAllJobs();
        }
    }

    enterSearchTerm(d,e) {
        console.log('nav-job-list:enterSearchTerm e: %o', e);
        
        if (e.keyCode == 13) {
            this.searchJobs();
            return false;
        }

        return true;
    }

    clickViewAllJobs() {

        this.searchTerm("");
        console.log("nav-job-list:clickViewAllJobs: searchTerm(): %o", this.searchTerm());
        this.OnetSearchArray([]);
        this.viewAllJobs();

    }

    addNewJob() {
        this.context.eventManager.notifySubscribers({callingComponent: this, type: "new"},"Show JDM-Modal");
    }

    addNewBlankJob(item) {

        console.log('nav-job-list:addNewBlankJob item: %o', item);
        

        let self = this;
        let NewTitle = "";

        let jobUtilObj = new jobUtil(this.context);

        BootstrapDialog.show({
            title: 'Job - New Blank Job',
            message: 'Job Title: <input type="text" id="nav-job-list-new-blank-job-input" value="" class="form-control">', 
            buttons: [{
                    label: 'Cancel',
                    action: function(result){
    
                        if(result) {
                            console.log('nav-job-list:addNewBlankJob Cancel: result %o', result);
                            result.close();
                        }
                    }
                },
                {
                label: 'Save',
                cssClass: 'btn-jdmGreen',
                action: function(result){

                    /*
                    then( response => {
                                jobUtilObj.getJobList();  
                            })
                    */

                    if(result) {

                        console.log('nav-job-list:addNewBlankJob Save: result %o', result);
                        console.log('nav-job-list:addNewBlankJob Save: input %o', result.getModalBody().find('input').val() );

                        let title = result.getModalBody().find('input').val();

                        if(title.length > 3)
                        {
                            console.log('nav-job-list:addNewBlankJobs SaveAs: title %o  jobUtilObj: %o', title, jobUtilObj);

                            jobUtilObj.saveDefaultJob(title,"  ").then( response => {
                                console.log('nav-job-list:addNewBlankJob response %o  result: %o', response, result);
                                result.close();
                                //jobUtilObj.getJobList();  
                                //self.context.eventManager.notifySubscribers({updateNav:true},"jobRefresh");
                            }).catch( response => {
                                console.log('nav-job-list:addNewBlankJob ERROR %o', response);
                            });
                            
                        }
                        else
                        {
                            alert('Job title required or Title length error');
                        }
                        
                    }
                }
            }]
        });
    }

    viewAllJobs() {
        ko.utils.arrayForEach(context.userJobsArray(), function(item) {
            item.rowVisible(true);
        });

        this.log(context.userJobsArray());
        context.userJobsArray.valueHasMutated();
    }

    searchUserJobs(string) {
        this.viewAllJobs();
        ko.utils.arrayForEach(context.userJobsArray(), function(item) {
            if(!_.includes(item.title().toUpperCase(), string.toUpperCase()))
            {
                item.rowVisible(false);
            }
        });
    }

    searchONetJobs(searchTerm) {

        let url = context.generateApiUrl('/Jobs/job/searchForJob');
        let callData = JSON.stringify({"searchTerm": searchTerm});
        
        console.log("nav-job-list:searchONetJobs: searchTerm: %o", searchTerm);

        //Clear Job List
        this.OnetSearchArray([]);

        axios({
            url: url,
            method: 'post',
            headers: this.context.apiContentType,
            data: callData
        }).then((response) => {
            this.log("searchONetJobs: data:")
            this.log(response.data);
            this.OnetSearchArray(response.data.data);
            console.log("nav-job-list:searchONetJobs: OnetSearchArray.length: %i", this.OnetSearchArray().length);

            if(this.OnetSearchArray().length == 0)
            {
                this.context.eventManager.notifySubscribers({helpHtml:"No jobs found for: <B>" + searchTerm + "</B>",helpTitle:"Search Results:",helpTitleCss:"helpModal"},"show-help-modal");
            }

        }).catch((error) =>{
            this.log("searchJob Error:");
            this.log(error);
            this.context.eventManager.notifySubscribers({modalTitle:"API Error",modalBody:"Error searching for Job"},"messageModel");
        });
    }

    saveChanges() {
        this.log("Save Changes:");
    }

    removeEditors() {

          
    }

    jobSelected(item,event) {
        console.log("nav-job-list:jobSelected: item: %o, evemt: %o",item,event);

        item.editorVisible(!item.editorVisible());
        item.rowVisible(!item.rowVisible());
    }

    newJobSelected(item, parent) {
        console.log("nav-job-list:newJobSelected: %o", item);
        parent.context.eventManager.notifySubscribers({type:"new",job:item},"Show JDM-Modal");
        
    }


    //Job list Sort
    invertSort() {

        console.log("nav-job-list:invertSort: AscDescClass: %o", this.AscDescClass());

        if(Array.prototype.sortColumnAsc === "Asc")
        {
            Array.prototype.sortColumnAsc = "Desc";
            this.AscDescClass("glyphicon-arrow-down");
        }
        else
        {
            Array.prototype.sortColumnAsc = "Asc";
            this.AscDescClass("glyphicon-arrow-up");
        }

        console.log("nav-job-list:invertSort: done: AscDescClass: %o", this.AscDescClass());
    }

    sortTableBy(columnToSort) {

        if(columnToSort === Array.prototype.sortColumn)
        {
            this.invertSort();
        }

        //console.log("nav-job-list:sortTableBy: parent: %o columnToSort: %o", parent, columnToSort);
        Array.prototype.sortColumn = columnToSort;
        this.sortColumn(columnToSort);
        this.context.userJobsArray.valueHasMutated();
        this.AscDescClass.valueHasMutated();

        console.log("nav-job-list:sortTableBy:Return this: %o  columnToSort: %o", this, Array.prototype.sortColumn);
    }

    columnSorter(itemRight, itemLeft) {

        let column = Array.prototype.sortColumn;
        let sortOrder = 1;

        let itemRightFormmatted = "";
        let itemLeftFormatted = "";

        switch(column)
        {
            case "datelastused":
                itemRightFormmatted = moment.utc(itemRight[column]()).format('x');
                itemLeftFormatted = moment.utc(itemLeft[column]()).format('x');
            break;

            default:
                itemRightFormmatted = itemRight[column]();
                itemLeftFormatted = itemLeft[column]();
            break;
        }

        console.log("nav-job-list:columnSorter:  itemRightFormmatted: %o, itemLeftFormatted, %o", itemRightFormmatted, itemLeftFormatted);

        let result = 0;

        if(Array.prototype.sortColumnAsc === "Desc")
        {
            result = (itemRightFormmatted < itemLeftFormatted) ? -1 : (itemRightFormmatted > itemLeftFormatted) ? 1 : 0;
        }
        else
        {
            result = (itemRightFormmatted > itemLeftFormatted) ? -1 : (itemRightFormmatted > itemLeftFormatted) ? 0 : 1;
        }

        return result * sortOrder;
        
    }


}

export default { viewModel: jobListModel, template: require('!raw-loader!./nav-job-list.html') };


// WEBPACK FOOTER //
// ./src/components/nav-job-list/nav-job-list.js